import script from "./PCChangeMachinePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PCChangeMachinePopup.vue?vue&type=script&setup=true&lang=js"

import "./PCChangeMachinePopup.vue?vue&type=style&index=0&id=40a63bc8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a63bc8"]])

export default __exports__